var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "travel-comment", attrs: { "data-rating": _vm.ratingAvg } },
    [
      _c("div", { staticClass: "media" }, [
        _c("div", { staticClass: "media-body" }, [
          _c("p", { staticClass: "lead-text" }, [
            _vm._v(
              _vm._s(_vm._f("toDateString")(_vm.date)) +
                " – " +
                _vm._s(_vm.name)
            ),
          ]),
          _vm._v(" "),
          _vm.ratingAvg
            ? _c("div", { staticClass: "visible-xs" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _c("div", { staticClass: "star-rating" }, [
                      _c(
                        "div",
                        { staticClass: "star-rating-icons" },
                        _vm._l(5, function (index) {
                          return _c("i", {
                            key: index,
                            staticClass: "icon icon-star",
                          })
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "star-rating-icons-overlay" },
                        [
                          _vm._l(parseInt(_vm.ratingAvg / 2), function (index) {
                            return _c("i", {
                              key: index,
                              staticClass: "icon icon-star",
                            })
                          }),
                          _vm._v(" "),
                          (_vm.ratingAvg / 2) % 1 >= 0.3
                            ? _c("i", { staticClass: "icon icon-star-half" })
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.text
            ? _c("div", [
                _c("strong", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.text))]),
                _vm._v(" "),
                _vm.comment
                  ? _c("blockquote", [
                      _c("strong", { staticClass: "colored" }, [
                        _vm._v("Antwort von company name"),
                      ]),
                      _c("br"),
                      _vm._v(
                        "\n          " + _vm._s(_vm.comment) + "\n        "
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.ratingAvg
          ? _c("div", { staticClass: "media-right hidden-xs" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "star-rating" }, [
                    _c(
                      "div",
                      { staticClass: "star-rating-icons" },
                      _vm._l(5, function (index) {
                        return _c("i", {
                          key: index,
                          staticClass: "icon icon-star",
                        })
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "star-rating-icons-overlay" },
                      [
                        _vm._l(parseInt(_vm.ratingAvg / 2), function (index) {
                          return _c("i", {
                            key: index,
                            staticClass: "icon icon-star",
                          })
                        }),
                        _vm._v(" "),
                        (_vm.ratingAvg / 2) % 1 >= 0.3
                          ? _c("i", { staticClass: "icon icon-star-half" })
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.detailRatings
        ? _c("div", { staticClass: "travel-rating-summary" }, [
            _c(
              "a",
              {
                staticClass: "travel-rating-detail-toggle collapsed",
                attrs: {
                  role: "button",
                  "data-toggle": "collapse",
                  "aria-expanded": "false",
                  "aria-controls": "bewertungen-collapse",
                  href: "#travel-rating-collapse-" + _vm.index,
                },
              },
              [
                _vm._v("Details\n      "),
                _c("span", { staticClass: "ein" }, [_vm._v(" einblenden")]),
                _c("span", { staticClass: "aus" }, [_vm._v(" ausblenden")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse travel-rating-groups",
                attrs: { id: "travel-rating-collapse-" + _vm.index },
              },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.detailRatings, function (d) {
                    return _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 col-md-6" },
                      [
                        _c("div", { staticClass: "travel-group-rating row" }, [
                          _c("div", { staticClass: "col-xs-12 col-sm-5" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(d.bezeichnung) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12 col-sm-7" }, [
                            _c("div", { staticClass: "star-rating" }, [
                              _c(
                                "div",
                                { staticClass: "star-rating-icons" },
                                _vm._l(5, function (index) {
                                  return _c("i", {
                                    key: index,
                                    staticClass: "icon icon-star",
                                  })
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "star-rating-icons-overlay" },
                                [
                                  _vm._l(
                                    parseInt(parseFloat(d.bewertung) / 2),
                                    function (index) {
                                      return _c("i", {
                                        key: index,
                                        staticClass: "icon icon-star",
                                      })
                                    }
                                  ),
                                  _vm._v(" "),
                                  (parseFloat(d.bewertung) / 2) % 1 >= 0.3
                                    ? _c("i", {
                                        staticClass: "icon icon-star-half",
                                      })
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }